@if (loading) {
  <div class="row d-flex justify-content-around">
    <div>
      <app-spinner></app-spinner>
    </div>
  </div>
}

<div (mouseleave)="chartLeave($event)" #container class="chart-container">
  <canvas #canvas  (click)="chartClicked($event)" (mousemove)="chartHovered($event)"
  [ngClass]="{'clickable' : clickable && level==='portfolio'}"></canvas>
  <div data-html2canvas-ignore  #tooltip class="popup shadow" [hidden]="!toolTipShow"  style.transform="translate({{popupLeft}}px, {{popupTop}}px)">
    @if (!clickable) {
      <div class="font-weight-bold font-size-normal">{{tooltipDate}}</div>
    }
    <div >
      <span> {{(level ==='portfolio'? 'COMMON.PARK' :'COMMON.TURBINE') | translate }} : </span>
      <span class="font-weight-bold" > {{tooltipAssetName}}</span>
    </div>
    @if (!clickable) {
      <div >
        <span> {{ tooltipLabel | translate }} : </span>
        <span class="font-weight-bold" > {{tooltipValue}} </span>
      </div>
    }
  </div>
</div>